/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import AssignCostCenterForm from './AssignCostCenterForm/AssignCostCenterForm';
import AssignCostCenterSuccess from './AssignCostCenterSuccess/AssignCostCenterSuccess';
import AssignCostCenterError from './AssignCostCenterError/AssignCostCenterError';
import Form from '../../../../../forms/_.extend';

import Loading from 'components/Loading/Loading';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  project: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AssignCostCenter extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const project: Object = this.props.project;

    const fields: Array<Object> = [
      {
        name: 'assignCostCenters',
        label: t('general:actions.select_cost_centers'),
        title: 'Select Cost Center(s)',
        fields: [
          {
            name: 'costCenterIds',
            label: t('general:labels.assignee'),
            rules: 'required|array',
            value: [],
            placeholder: t('general:placeholders.cost_center_code_name'),
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { costCenterIds }: Object = data.values().assignCostCenters;

        actionDrawerStore.assignCostCentreToProject(project.id, {
          cost_centres: costCenterIds,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: t('general:actions.assign_cost_centers'),
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const project: Object = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.assign_cost_centers')} />
          <AssignCostCenterError {...project} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.assign_cost_centers')} />
          <AssignCostCenterSuccess {...project} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.assign_cost_centers')} />
        <AssignCostCenterForm {...project} form={this.createForm()} />
      </div>
    );
  }
}
